module.exports = __webpack_public_path__ + "img/source-sans-pro-v13-latin-regular.3d536f38.svg";